import RouteMap from "./RouteMap";

export default RouteMap;
